

const wPrimType = {
    wPrimUnknown: -1,
    wPrimPoint: 0,
    wPrimLine: 1,
    wPrimTriangle: 2,
    wPrimQuad: 3,
    wPrimPlane: 4,
    wPrimBox: 5,
    wPrimBox2D: 6,
    wPrimSphere: 7,
    wPrimEllipsoid: 8,
    wPrimCylinder: 9,
    wPrimCone: 10,
    wPrimTorus: 11,
    wPrimPyramid: 12,
    wPrimWedge: 13,
    wPrimOrientedBox: 14,
}

class wPrim {
    constructor(name, primitiveType) {
        this.name_ = name;
        this.type_ = primitiveType;
    }

    getName() { return this.name_; }
    getType() { return this.type_; }
}

export { wPrim, wPrimType }